import React, { useEffect, useState } from 'react';
import {
    Terminal,
    RefreshCw,
    User,
    Monitor,
    Clock,
    AlertCircle
} from 'lucide-react';
import { LysepAPI } from '../../../contexts/ApiContext';
import { toast } from 'react-toastify';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "../../../components/ui/Table";
import { Badge } from "../../../components/ui/Badge";

const SshTab = ({ serverId }) => {
    const [sessions, setSessions] = useState([]);
    const [fetching, setFetching] = useState(false);
    const [lastUpdated, setLastUpdated] = useState(null);

    const fetchSessions = async () => {
        setFetching(true);
        try {
            const resp = await LysepAPI.post(`/api/servers/${serverId}/ssh/sessions/fetch`);
            if (resp.data.state) {
                setSessions(resp.data.data);
                setLastUpdated(new Date());
            } else {
                toast.error(`Kayıtlar getirilemedi: ${resp.data.message}`);
            }
        } catch (err) {
            toast.error(`Hata: ${err.message}`);
        } finally {
            setFetching(false);
        }
    };

    useEffect(() => {
        fetchSessions();
    }, [serverId]);

    return (
        <div className="animate-fadeIn">
            <div className="bg-[#1a1a1a] border border-white/10 rounded-xl overflow-hidden shadow-lg mb-6">
                <div className="p-4 border-b border-white/10 bg-[#252525] flex items-center justify-between">
                    <div className="flex items-center gap-2">
                        <Terminal className="w-5 h-5 text-gray-400" />
                        <h3 className="font-semibold text-white uppercase tracking-wider text-sm">
                            Aktif Oturumlar (SSH Sessions)
                        </h3>
                    </div>
                    <div className="flex items-center gap-4">
                        {lastUpdated && (
                            <span className="text-xs text-gray-400">
                                Son Güncelleme: {lastUpdated.toLocaleTimeString()}
                            </span>
                        )}
                        <button
                            onClick={fetchSessions}
                            disabled={fetching}
                            className="flex items-center gap-2 px-3 py-1.5 text-xs font-medium text-gray-300 hover:text-white border border-white/10 hover:border-white/20 rounded-lg transition-colors bg-[#1e1e1e] hover:bg-[#2a2a2a] disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            <RefreshCw className={`w-3.5 h-3.5 ${fetching ? 'animate-spin' : ''}`} />
                            Yenile
                        </button>
                    </div>
                </div>

                <div className="p-0">
                    {sessions.length === 0 && !fetching ? (
                        <div className="flex flex-col items-center justify-center py-12 text-gray-400">
                            <Terminal className="w-8 h-8 opacity-20 mb-2" />
                            <p className="text-sm">Aktif oturum bulunamadı.</p>
                        </div>
                    ) : (
                        <Table>
                            <TableHeader>
                                <TableRow>
                                    <TableHead className="w-1/4">
                                        <div className="flex items-center gap-2">
                                            <User className="w-4 h-4 opacity-70" />
                                            Kullanıcı
                                        </div>
                                    </TableHead>
                                    <TableHead className="w-1/4">
                                        <div className="flex items-center gap-2">
                                            <Terminal className="w-4 h-4 opacity-70" />
                                            TTY
                                        </div>
                                    </TableHead>
                                    <TableHead className="w-1/4">
                                        <div className="flex items-center gap-2">
                                            <Monitor className="w-4 h-4 opacity-70" />
                                            IP / Host
                                        </div>
                                    </TableHead>
                                    <TableHead className="w-1/4">
                                        <div className="flex items-center gap-2">
                                            <Clock className="w-4 h-4 opacity-70" />
                                            Bağlantı Zamanı
                                        </div>
                                    </TableHead>
                                </TableRow>
                            </TableHeader>
                            <TableBody>
                                {sessions.map((session, idx) => (
                                    <TableRow key={idx}>
                                        <TableCell>
                                            <Badge variant="default" className="gap-1.5">
                                                <User className="w-3 h-3" />
                                                {session.user}
                                            </Badge>
                                        </TableCell>
                                        <TableCell className="font-mono text-gray-300">{session.tty}</TableCell>
                                        <TableCell className="font-mono text-gray-300">{session.ip || '-'}</TableCell>
                                        <TableCell className="text-gray-400">{session.login_time}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SshTab;
